import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { GuestLinkAclResponseSchema } from './acl';
import { GuestLinkBaseResponseSchema } from './guest-link-base-response.dto';
export const GuestLinkDetailedResponseSchema = GuestLinkBaseResponseSchema.extend({
    guestLinkAcl: z.array(GuestLinkAclResponseSchema),
});
export class GuestLinkDetailedResponseDto extends createZodDto(GuestLinkDetailedResponseSchema) {
}
